import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { AppRoutes } from '@app/utils/enums/routes.enum';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [IconComponent, RouterModule],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  public IconName = IconName;
  private readonly authService = inject(AuthService);

  protected readonly homeRoute = computed(() =>
    this.authService.isLoggedIn() ? AppRoutes.MAIN : '/',
  );
}
